module.exports = __webpack_public_path__ + "img/ill-home-skills-header.eac05fd1.svg";